import React, { useEffect, useRef, useState } from "react";



const KakaoMap = ({ latitude, longitude, onAddressChange }) => {
    const mapRef = useRef(null);
    const [address, setAddress] = useState("주소를 불러오는 중...");

    useEffect(() => {
        const loadKakaoMapScript = () => {
            return new Promise((resolve, reject) => {
                if (window.kakao && window.kakao.maps) {
                    resolve("Kakao Map API is loaded");
                } else {
                    const script = document.createElement("script");                    
                    script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=d7ae19a6101738fc44ac012874d79a76&libraries=services`;
                    script.async = true; // 비동기 로드
                    //script.defer = true; // HTML 파싱 후 실행
                    script.onload = () => resolve("Kakao Map API loaded successfully");
                    script.onerror = () => reject("Failed to load Kakao Map API");


                    document.body.appendChild(script);
                }
            });
        };

        loadKakaoMapScript()
            .then(() => {
                // 카카오 지도 API 로드 후 실행
                if (latitude && longitude) {
                    //console.log("Latitude:", latitude, "Longitude:", longitude);  // 좌표 확인

                    const container = mapRef.current;
                    const options = {
                        center: new window.kakao.maps.LatLng(latitude, longitude),
                        level: 3,
                    };

                    // 지도 생성
                    const map = new window.kakao.maps.Map(container, options);

                    // 지도 타입을 스카이뷰로 설정
                    //map.setMapTypeId(window.kakao.maps.MapTypeId.SKYVIEW);

                    // 📌 하이브리드 맵 (스카이뷰 + 지명)
                    map.setMapTypeId(window.kakao.maps.MapTypeId.HYBRID);

                    // 마커 생성
                    new window.kakao.maps.Marker({
                        position: new window.kakao.maps.LatLng(latitude, longitude),
                        map: map,
                    });

                    try {
                        // 주소 변환
                        const geocoder = new window.kakao.maps.services.Geocoder();
                        geocoder.coord2Address(longitude, latitude, (result, status) => {
                            if (status === window.kakao.maps.services.Status.OK) {
                                const roadAddress = result[0]?.road_address?.address_name || "";
                                const jibunAddress = result[0]?.address?.address_name || "";
                                const finalAddress = roadAddress || jibunAddress || "주소를 찾을 수 없습니다.";

                                setAddress(finalAddress);

                                // 📌 주소가 변경될 때 상위 컴포넌트로 전달
                                if (onAddressChange) {
                                    onAddressChange(finalAddress);
                                }
                            }
                        });
                    }
                    catch (error) {
                        console.log(error)
                    }
                    
                } else {
                    console.error("유효한 위도, 경도 값이 아닙니다.");
                }
            })
            .catch((error) => {
                console.error(error);
            });


    }, [latitude, longitude]);

    return (
        <div>
            {/* 카카오맵 컨테이너 */}
            <div ref={mapRef} style={{
                width: "100%",
                paddingBottom: "70%", // 2/3 비율 (100% * 2 / 3 = 66.666%)
                position: "relative",
            }}></div>

            {/* 지도 아래 주소 표시 */}
            <div className="address-container">                
                {address}
            </div>
        </div>
    );
};

export default KakaoMap;


